import React from 'react';
import './PastEvents.css';

import wchair from '../assets/posters/wchairbadge.jpg';
import wvicechair from '../assets/posters/wvicechairbadge.jpg';
import wsecretary from '../assets/posters/wsecretarybadge.jpg';
import wtreasurer from '../assets/posters/wtreasurerbadge.jpg';
import wwebmaster1 from '../assets/posters/wwebmasterbadge1.jpg';
import wwebmaster2 from '../assets/posters/wwebmasterbadge2.jpg';
import wmchair from '../assets/posters/wmchairbadge.jpg';

const pastPosters = [
    wchair,
    wvicechair,
    wsecretary,
    wtreasurer,
    wwebmaster1,
    wwebmaster2,
    wmchair
];

const PastEvents = () => {
    return (
        <section className="past-events-section">
            <div className="posters-carousel-container">
                {/* This track will scroll in the reverse direction */}
                <div className="posters-carousel-track-reverse">
                    {/* Render posters twice for a seamless loop */}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past1-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                    {pastPosters.map((poster, index) => (
                        <div className="poster-card" key={`past2-${index}`}>
                            <img src={poster} alt={`Past Event Poster ${index + 1}`} />
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default PastEvents;
